(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ContractDialogController', ContractDialogController);

    ContractDialogController.$inject = ['$timeout', '$rootScope', '$scope', '$http', 'Principal', '$uibModal', '$state', '$stateParams', '$q', '$anchorScroll', '$location', 'entity',
        'Contract', 'PremDiscGroup', 'Company', 'Location', 'Contact', 'Port', 'ActivityHistory', 'Comment', 'Delivery', 'Fixation', 'Shipment', 'Lot',
        'MiscService', 'ContractCustomService', 'CompanyCustomService', 'ContactCustomService', 'ShipmentCustomService', 'LocationCustomService', 'KeywordCustomService', 'CountryCustomService',
        'PortCustomService', 'ToastrService', 'Pricing', 'PricingCustomService', 'FormulaCustomService', 'Growth', 'category',
        'CommentCustomService', 'AttachmentCustomService'];

    function ContractDialogController($timeout, $rootScope, $scope, $http, Principal, $uibModal, $state, $stateParams, $q, $anchorScroll, $location, entity,
                                      Contract, PremDiscGroup, Company, Location, Contact, Port, ActivityHistory, Comment, Delivery, Fixation, Shipment, Lot,
                                      MiscService, ContractCustomService, CompanyCustomService, ContactCustomService, ShipmentCustomService, LocationCustomService, KeywordCustomService,
                                      CountryCustomService, PortCustomService, ToastrService, Pricing, PricingCustomService, FormulaCustomService, Growth, category,
                                      CommentCustomService, AttachmentCustomService ) {
        var vm = this;

        vm.contract = entity;
        vm.category = category;
        vm.toFixationForm = toFixationForm;
        vm.loadContractPricing = loadContractPricing;
        vm.loadContractFixations = loadContractFixations;
        vm.hideFixations = hideFixations;
        vm.getActiveTab = getActiveTab;
        vm.buildCropYear = buildCropYear;
        vm.resolveCropYear = resolveCropYear;
        vm.refreshPricing = refreshPricing;
        vm.updateQualityDisplayField = updateQualityDisplayField;
        vm.resolveQualities = resolveQualities;
        vm.calcCurBalNew = calcCurBalNew;
        vm.removePlannedShipment = removePlannedShipment;
        vm.updateIndexes = updateIndexes;
        vm.nl2br = MiscService.nl2br;


        vm.plannedShipments = [];
        vm.contractPricing = [];
        vm.contractFixations = [];
        vm.contractFixationsAvg = 0;
        vm.contractFinalFixationsAvg = 0;
        vm.contractFixationsQtyTotal = 0;
        vm.showFixations = false;
        vm.comments = [];
        vm.comment = "";
        vm.attachments = [];

        function toFixationForm() {
            var data = {
                heading: 'Fixation for Contract',
                route: 'purchase.fixation-form',
                param: {contractId: vm.contract.id},
                id: vm.contract.id
            };
            $scope.$emit('handleEmit', data);
        }

        vm.selectedPlannedShipments = [];
        $scope.psGridOptions = {
            modifierKeysToMultiSelectCells: true,
            keyDownOverrides: [{keyCode: 39, ctrlKey: true}],
            showGridFooter: true,
            enableSorting: true,
            onRegisterApi: function (gridApi) {
                $scope.gridApi = gridApi;
                gridApi.edit.on.afterCellEdit($scope, function () {
                    calcCurBal();
                });
            },
            data: vm.plannedShipments,
            columnDefs: [
                {name: 'shipPeriod', enableSorting: true},
                {name: "shipMonth"},
                {name: 'shipYear'},
                {name: 'plannedQty', type: 'number', enableCellEdit: true, cellClass: 'blue'},
                {name: 'allocQty', type: 'number', enableCellEdit: false},
                {name: 'allocBal', type: 'number', enableCellEdit: false},
                {name: 'siQty', type: 'number', enableCellEdit: false},
                {name: 'siBal', type: 'number', enableCellEdit: false},
                {name: 'shippedQty', type: 'number', enableCellEdit: false},
                {name: 'shippedBal', type: 'number', enableCellEdit: false},
                {
                    name: 'Create',
                    cellTemplate: '<div class="ui-grid-cell-contents"><button class="btn btn-success btn-xs" type="button" ng-click="grid.appScope.addShipment(row)">Add</button></div>',
                    enableCellEdit: false
                },
                {
                    name: 'Del',
                    cellTemplate: '<div class="ui-grid-cell-contents"><button class="btn btn-danger btn-xs" type="button" ng-click="grid.appScope.removePsRow(row)">Remove</button></div>',
                    enableCellEdit: false
                }
            ]
        };

        if (vm.contract.id === null) {
            vm.activity = 'new';
            vm.contract.createdOn = new Date();
            vm.contract.modifiedOn = vm.contract.createdOn;
            vm.contract.tolerance = 3;
            vm.contract.tolType = '+/-';
            vm.currentContractBalance = 0;
            if ($stateParams.subCategory && $stateParams.subCategory.length > 0) {
                switch ($stateParams.subCategory) {
                    case 'ISSUED':
                    case 'DRAFT':
                    case 'COMPLETE':
                    case 'CANCELLED':
                        vm.contract.status = $stateParams.subCategory;
                        break;
                    default:
                        break;
                }
            }
        } else {
            vm.activity = 'edit';
            vm.contract.modifiedOn = new Date();
            ContractCustomService.getPlannedShipmentsByContract(vm.contract.id).then(function (it) {
                vm.plannedShipmentsNew = it.data;
                calcCurBalNew();
                vm.updateIndexes();
               // vm.plannedShipments = it.data;
               // calcCurBal();
               // $scope.psGridOptions.data = vm.plannedShipments;
            });
            resolveComments();
            resolveAttachments();
        }

        //Defaults
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.autoQtyDisplay = autoQtyDisplay;
        vm.autoQualityDisplay = autoQualityDisplay;
        vm.save = save;

        $scope.addShipment = function (row) {
            console.log('Adding a shipment for period: ' + row.entity.shipPeriod + ' against ' + vm.contract.contractNum);
            var paramData = {paramId: vm.contract.id, paramM: row.entity.shipMonth, paramY: row.entity.shipYear};
            var data = {
                heading: 'New ' + row.entity.shipPeriod,
                route: 'shipment.new',
                id: '',
                param: paramData
            };
            $rootScope.$emit('handleEmit', data);
        };

        $scope.removePsRow = function (row) {
            var index = $scope.psGridOptions.data.indexOf(row.entity);
            $scope.psGridOptions.data.splice(index, 1);
            calcCurBal();
        };

        Principal.identity().then(function (account) {
            vm.account = account;
            vm.isAuthenticated = Principal.isAuthenticated;
            if (vm.activity === "new") {
                vm.contract.createdBy = account.login;
                vm.contract.modifiedBy = vm.contract.createdBy;
                vm.contract.myUuid = generateUUID();
                vm.altQty = '';
                vm.buyer = "";
                vm.buyerLocation = "";
                vm.buyerContact = "";
                vm.seller = "";
                vm.sellerLocation = "";
                vm.sellerContact = "";
                vm.thirdPartyName = "";
                vm.thirdPartyLocation = "";
                vm.thirdPartyContact = "";
                vm.growth = "";
                vm.loadingCountry = "";
                vm.loadingPort = "";
                vm.destinationCountry = "";
                vm.destinationPort = "";
            } else {
                vm.contract.modifiedBy = account.login;
                vm.contract.modifiedOn = new Date();
                vm.altQty = vm.contract.altQty;
                vm.buyer = vm.contract.buyer;
                vm.buyerLocation = vm.contract.buyerLocation;
                vm.buyerContact = vm.contract.buyerContact;
                vm.seller = vm.contract.seller;
                vm.sellerLocation = vm.contract.sellerLocation;
                vm.sellerContact = vm.contract.sellerContact;
                vm.thirdPartyName = vm.contract.thirdParty;
                vm.thirdPartyLocation = vm.contract.thirdPartyLocation;
                vm.thirdPartyContact = vm.contract.thirdPartyContact;
                vm.growth = vm.contract.growth;
                vm.loadingCountry = vm.contract.loadingCountry;
                vm.loadingPort = vm.contract.loadingPort;
                vm.destinationCountry = vm.contract.destinationCountry;
                vm.destinationPort = vm.contract.destinationPort;

            }

        });
        vm.type = vm.contract.contractType;
        vm.qtyUnitTypes = ['BALES', 'MTS'];
        vm.priceModels = ['ONCALL', 'FIXED'];
        vm.priceTypes = ['CTS', 'CPTS', 'USD', 'EUR'];
        vm.unitTypes = ['LB', 'MT', 'KG'];
        vm.contractTypes = ['SALE', 'PURCHASE'];
        vm.qualityTypes = ['DESCRIPTION', 'GREEN_CARD'];
        vm.paymentTypes = ['CAD', "LC"];

        vm.qualityDescriptionGrade = ['PIMA', 'GM', 'SM', 'MID', 'SLM', 'LM', 'SGO', 'GO', 'MID LS', 'SLM LS', 'LM LM', 'MID SP', 'SLM SP', 'LM SP'];
        vm.qualityDescriptionStaple = ['1-3/16', '1-5/32', '1-1/8', '1-3/32', '1-1/16', '1-1/32', '1'];
        vm.qualityGreenCardGrade = ['11', '21', '31', '41', '51', '12', '22', '32', '42', '52', '23', '33', '43', '53', '1', '2', '3', '4'];
        vm.qualityGreenCardLeaf = ['1', '2', '3', '4', '5', '6', '7'];
        vm.qualityGreenCardStaple = ['46', '44', '42', '40', '39', '38', '37', '36', '35', '34', '33', '32'];
        vm.qualityDescriptionGreenCardMic = ['G5', 'G6', 'G567', '3.0NCL', '3.5NCL', '5.0NCL', '3.0/4.9 NCL', '3.5/5.3 NCL', '3.8/4.9 NCL', '3.8/4.8 NCL', '3.7/4.8 NCL', '4.0/5.2 NCL', '4.7/5.5 NCL'];
        vm.qualityDescriptionGreenCardStrength = ['24 GPT', '25 GPT', '26 GPT', '27 GPT', '28 GPT', '29 GPT', '30 GPT', '31 GPT', '32 GPT', '33 GPT', '34 GPT', '35 GPT', '36 GPT', '37 GPT', '38 GPT', '39 GPT', '40 GPT'];
        vm.qualityDescriptionGreenCardStrengthRange = ['MIN', 'AVG'];
        vm.qualityDescriptionGreenCardRange = ['MIN', 'AVG'];
        vm.qualityDescriptionGreenCardUniformity = ['80', '81'];

        function updateQualityDisplayField(fieldName, value) {
            vm.contract[fieldName] = value;
        }

        vm.premdiscgroups = PremDiscGroup.query({filter: 'contract-is-null'});

        resolveShipments();

        vm.activate = function (option) {
            option.active = !option.active;
            vm.buildCropYear();
        };

        function resolveCropYear(cropYear) {
            if (cropYear && cropYear !== null && cropYear.length > 0) {
                var contractCropYear = cropYear.split(';');
                if (contractCropYear && vm.cropYears) {
                    for (var j = 0; j < contractCropYear.length; j++) {
                        for (var i = 0; i < vm.cropYears.length; i++) {
                            if (vm.cropYears[i].year === contractCropYear[j]) {
                                vm.cropYears[i].active = true;
                            }
                        }
                    }
                }
            }
        }

        function buildCropYear() {
            var cropYearValue = '';
            var first = true;
            for (var i = 0; i < vm.cropYears.length; i++) {
                if (vm.cropYears[i].active) {
                    cropYearValue += (first ? '' : ';') + vm.cropYears[i].year;
                    first = false;
                }
            }
            vm.contract.cropYear = cropYearValue.length > 0 ? cropYearValue : undefined;
        }

        vm.leavePriceTab = function () {
            if (vm.contract.priceModel === 'ONCALL') {
                vm.autoPriceDisplay();
            }
        };

        vm.addNewCountry = function (type) {
            $uibModal.open({
                templateUrl: 'app/entities/country/country-dialog.html',
                controller: 'CountryDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function () {
                        return {
                            // createdOn: new Date(),
                            // createdBy: "user",
                            // modifiedOn: new Date(),
                            // modifiedBy: "user",
                            name: null,
                            code: null,
                            id: null
                        };
                    }
                }
            }).result.then(function (retVal) {
                vm.countries.push(retVal);
                if (type === 'origin') {
                    vm.contract.loadingCountry = retVal;
                } else {
                    vm.contract.destinationCountry = retVal;
                }
            })
        };

        vm.addNewPort = function (type) {
            var prt = null;
            if (type === 'origin') {
                prt = vm.contract.loadingCountry;
            } else {
                prt = vm.contract.destinationCountry;
            }
            $uibModal.open({
                templateUrl: 'app/entities/port/port-dialog.html',
                controller: 'PortDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function () {
                        return {
                            createdOn: new Date(),
                            createdBy: "user",
                            modifiedOn: new Date(),
                            modifiedBy: "user",
                            country: prt,
                            name: null,
                            id: null
                        };
                    }
                }
            }).result.then(function (retVal) {
                if (type === 'origin') {
                    vm.loadingPorts.push(retVal);
                    vm.contract.loadingPort = retVal;
                } else {
                    vm.destinationPorts.push(retVal);
                    vm.contract.destinationPort = retVal;
                }
            })
        };

        $scope.template = $("#template").html();

        vm.autoPriceDisplay = function () {
            if (vm.contract.priceModel === 'FIXED') {
                vm.contract.priceDisplay = '';
                var fixedPrice = ( vm.contract.fixedPrice && vm.contract.fixedPrice !== null ) ? vm.contract.fixedPrice : '';
                var priceType = (vm.contract.priceType && vm.contract.priceType !== null) ? (' ' + vm.contract.priceType) : '';
                var unitType = (vm.contract.unitType && vm.contract.unitType !== null) ? (' / ' + vm.contract.unitType) : '';
                vm.contract.priceDisplay = fixedPrice + priceType + unitType;
            } else {
                if (vm.contractPricing && vm.contractPricing.length > 0) {
                    vm.contract.priceDisplay = '';
                    for (var i = 0; i < vm.contractPricing.length; i++) {
                        var item = vm.contractPricing[i];
                        var pd = item.quantity + ' ' + vm.contract.qtyUnitType + ' @ ' + item.price + 'c ' + item.onOff + ' ' + item.month + item.year + ' ICE';
                        vm.contract.priceDisplay += (i > 0 ? ', ' : '') + pd;
                    }
                }
            }
        };

        vm.addShipmentPeriod = function () {
            var ps = {
                "shipPeriod": '',
                "shipMonth": '',
                "shipYear": '',
                "plannedQty": 0,
                "allocQty": 0,
                "allocBal": 0,
                "siQty": 0,
                "siBal": 0,
                "shippedQty": 0,
                "shippedBal": 0
            };
            vm.plannedShipments.push(ps);
            vm.selectedPlannedShipments.push(ps);
            calcCurBal();
            $scope.psGridOptions.data = vm.plannedShipments;
            $scope.gridApi.grid.refresh();
        };

        vm.plannedShipmentsNew = [];
        vm.months = ['January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'];
        vm.years = MiscService.returnPlannerYears();
        vm.addShipmentPeriodNew = function () {
            var ps = {
                "shipMonth": null,
                "shipYear": null,
                "plannedQty": null
            };
            vm.plannedShipmentsNew.push(ps);
            vm.updateIndexes();
            calcCurBalNew();
        };

        vm.autoShipPerDisplay = function() {
            var x = vm.plannedShipmentsNew.length;
            if( x > 0 ) {
                vm.contract.shipmentPeriodDisplay = ' ';
                var years = vm.plannedShipmentsNew.map(function(obj){return obj.shipYear;});
                years = years.filter(function(v,i){return years.indexOf(v) == i;});
                if( years.length > 1 ) {
                    for( var y = 0; y < years.length; y++ ) {
                        var stringToAdd = ' ';
                        if( y > 0 ) {vm.contract.shipmentPeriodDisplay += ", ";}
                        for( var i = 0; i < x; i++ ) {
                            if( vm.plannedShipmentsNew[i].shipYear === years[y] ) {
                                if( stringToAdd !== ' ') { stringToAdd += "/";}
                                stringToAdd += vm.plannedShipmentsNew[i].shipMonth;
                            }
                        }
                        stringToAdd += " " + years[y];
                        vm.contract.shipmentPeriodDisplay += stringToAdd;
                    }
                } else {
                    for(var i = 0; i < x; i++) {
                        if(vm.contract.shipmentPeriodDisplay !== ' ') { vm.contract.shipmentPeriodDisplay += "/"; }
                        vm.contract.shipmentPeriodDisplay += vm.plannedShipmentsNew[i].shipMonth;
                    }
                    vm.contract.shipmentPeriodDisplay += " " + vm.plannedShipmentsNew[0].shipYear;
                }
                if(eqShipPerDisplayFormat()) { vm.contract.shipmentPeriodDisplay += ", equally"; }
            }
        };

        function eqShipPerDisplayFormat() {
            var qty = vm.plannedShipmentsNew.map(function(obj){return obj.plannedQty;});
            qty = qty.filter(function(v,i){return qty.indexOf(v) == i;});
            return qty.length === 1;
        }

        function updateIndexes() {
            for (var i = 0; i < vm.plannedShipmentsNew.length; i++) {
                vm.plannedShipmentsNew[i].index = i;
            }
        }

        function removePlannedShipment(index) {
            var indexToRemove = -1;
            for (var i = 0; i < vm.plannedShipmentsNew.length; i++) {
                if (vm.plannedShipmentsNew[i].index === index) {
                    indexToRemove = i;
                }
            }
            if (indexToRemove > -1) {
                vm.plannedShipmentsNew.splice(indexToRemove, 1);
            }
            vm.updateIndexes();
        }

        vm.addFixation = function () {
            $uibModal.open({
                templateUrl: 'app/entities/keyword/keyword-dialog.html',
                controller: 'KeywordDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function () {
                        return {
                            createdOn: new Date(),
                            createdBy: "user",
                            modifiedOn: new Date(),
                            modifiedBy: "user",
                            type: type,
                            value: 0,
                            desc: null,
                            id: null
                        };
                    }
                }
            }).result.then(function (retVal) {
                // FIXME add implementation
            }, function (error) {
                // FIXME Add alert notification
            });
        };

        function calcCurBal() {
            /*var pShipments = vm.plannedShipments;
            var curBal = 0;

            if (pShipments.length === 0) {
                if (vm.contract.qtyUnitType === 'BALES') {
                    vm.currentContractBalance = vm.contract.qtyBales - curBal;
                } else {
                    vm.currentContractBalance = vm.contract.qtyMts - curBal;
                }
            }

            pShipments.forEach(function (element) {
                //TODO: Unfake this stuff when we're ready to get some meaningful data...
                // Kinda like this:
                var anId = '';

                if (vm.contract.id === null) {
                    anId = vm.contract.myUuid;
                } else {
                    anId = vm.contract.id;
                }

                curBal += element.plannedQty;
                if (element.shipPeriod) {
                    var moyr = element.shipPeriod.split(' ');
                    element['sortDate'] = moment(moyr[0] + ' 01' + ' 20' + moyr[1], 'MMM DD YYYY');
                }
            });

            if (curBal && !isNaN(curBal)) {
                if (vm.contract.qtyUnitType === 'BALES') {
                    vm.currentContractBalance = vm.contract.qtyBales - curBal;
                } else {
                    vm.currentContractBalance = vm.contract.qtyMts - curBal;
                }
            }

            vm.plannedShipments.sort(function (a, b) {
                return new Date(a.sortDate) - new Date(b.sortDate);
            })*/
            calcCurBalNew();
        }

        function calcCurBalNew() {
            var pShipments = vm.plannedShipmentsNew;
            var curBal = 0;

            if (pShipments.length === 0) {
                if (vm.contract.qtyUnitType === 'BALES') {
                    vm.currentContractBalance = vm.contract.qtyBales - curBal;
                } else {
                    vm.currentContractBalance = vm.contract.qtyMts - curBal;
                }
            }

            pShipments.forEach(function (element) {
                curBal += element.plannedQty * 1.0;
            });

            if (curBal && !isNaN(curBal)) {
                if (vm.contract.qtyUnitType === 'BALES') {
                    vm.currentContractBalance = vm.contract.qtyBales - curBal;
                } else {
                    vm.currentContractBalance = vm.contract.qtyMts - curBal;
                }
            }
        }

        $scope.onChange = function (data) {
            $scope.selected = data;
        };

        vm.activateQtyUnitType = function (option) {
            vm.contract.qtyUnitType = option;
            if (vm.contract.qtyUnitType && vm.contract.quantity) {
                vm.calcAltQty();
            }
        };

        vm.activateContractType = function (option) {
            vm.contract.contractType = option;
        };

        vm.activateQualityType = function (option) {
            vm.contract.quality = option === 'GREEN CARD' ? 'GREEN_CARD' : option;
        };

        vm.activatePriceModel = function (option) {
            vm.contract.priceModel = option;
        };

        vm.activatePriceType = function (option) {
            vm.contract.priceType = option;
            $scope.resolveDisplays('price');
        };

        vm.activateUnitType = function (option) {
            vm.contract.unitType = option;
            $scope.resolveDisplays('price');
        };

        vm.activatePaymentType = function (option) {
            vm.contract.paymentType = option;
        };

        vm.calcAltQty = function () {
            if (vm.contract.qtyUnitType && vm.contract.quantity) {
                switch (vm.contract.qtyUnitType) {
                    case 'BALES' :
                        vm.contract.qtyBales = vm.contract.quantity;
                        vm.contract.qtyLbs = Math.round((vm.contract.quantity * 501.05) * 100) / 100;
                        vm.contract.qtyKgs = Math.round((vm.contract.qtyLbs / 2.2046) * 100) / 100;
                        vm.contract.qtyMts = Math.round((vm.contract.qtyKgs / 1000) * 10) / 10;
                        vm.currentContractBalance = vm.contract.qtyBales;
                        FormulaCustomService.calculateGrowthBaleToWeightUnitConversionBD(vm.contract.growth.id, "LBS", vm.contract.quantity).then(function (data) {
                            console.log("returning: About " + data.data + " LBS");
                            vm.altQty = 'About ' + data.data + ' LBS';
                            vm.autoQtyDisplay();
                        }, function (error) {
                            if (error.status !== "404") {
                                ToastrService.error("Cannot get conversion for Bale to Lbs", "Error");
                            }
                            console.log(error.message);
                            console.log("returning null");
                            vm.altQty = null;
                        });
                        break;
                    case 'MTS' :
                        vm.contract.qtyKgs = Math.round((vm.contract.quantity * 1000) * 100) / 100;
                        vm.contract.qtyLbs = Math.round((vm.contract.quantity * 2204.6) * 100) / 100;
                        vm.contract.qtyMts = Math.round((vm.contract.quantity) * 10) / 10;
                        vm.contract.qtyBales = Math.round((vm.contract.qtyLbs / 496.08) * 10) / 10;
                        vm.currentContractBalance = vm.contract.qtyMts;
                        FormulaCustomService.calculateWeightUnitConversionBD("MTS", "LBS", vm.contract.quantity).then(function (data) {
                            console.log("returning: About " + data.data + " LBS");
                            vm.altQty = 'About ' + data.data + ' LBS';
                            vm.autoQtyDisplay();
                        }, function (error) {
                            if (error.status !== "404") {
                                ToastrService.error("Cannot get conversion for Mts to Lbs", "Error");
                            }
                            console.log(error.message);
                            console.log("returning null");
                            vm.altQty = null;
                        });
                        break;
                }
            }
        };

        vm.autoValueDisplay = function () {
            var price = 0;
            var variablePrice = ( vm.contract.fixedPrice && vm.contract.fixedPrice !== null ) ? vm.contract.fixedPrice : 0;
            if (vm.contract.priceType === 'CPTS') {
                price = variablePrice / 1000;
            } else {
                price = variablePrice;
            }
            switch (vm.contract.unitType) {
                case 'LB' :
                    vm.contract.priceValue = Math.round(( price / 100 * vm.contract.qtyLbs ) * 100) / 100;
                    break;
                case 'MT' :
                    vm.contract.priceValue = Math.round(( price / 100 * vm.contract.qtyMts ) * 100) / 100;
                    break;
                case 'KG' :
                    vm.contract.priceValue = Math.round(( price / 100 * vm.contract.qtyKgs ) * 100) / 100;
                    break;
            }
        };

        $q.all([vm.contract.$promise, vm.premdiscgroups.$promise]).then(function () {
            if (!vm.contract.premDiscGroup || !vm.contract.premDiscGroup.id) {
                return $q.reject();
            }
            return PremDiscGroup.get({id: vm.contract.premDiscGroup.id}).$promise;
        }).then(function (premDiscGroup) {
            vm.premdiscgroups.push(premDiscGroup);
        });
        vm.sellers = Company.query({filter: 'contract-is-null'});
        $q.all([vm.contract.$promise, vm.sellers.$promise]).then(function () {
            if (!vm.contract.seller || !vm.contract.seller.id) {
                return $q.reject();
            }
            return Company.get({id: vm.contract.seller.id}).$promise;
        }).then(function (seller) {
            vm.sellers.push(seller);
        });
        vm.sellercontacts = Contact.query({filter: 'contract-is-null'});
        $q.all([vm.contract.$promise, vm.sellercontacts.$promise]).then(function () {
            if (!vm.contract.sellerContact || !vm.contract.sellerContact.id) {
                return $q.reject();
            }
            return Contact.get({id: vm.contract.sellerContact.id}).$promise;
        }).then(function (sellerContact) {
            vm.sellercontacts.push(sellerContact);
        });
        vm.buyers = Company.query({filter: 'contract-is-null'});
        $q.all([vm.contract.$promise, vm.buyers.$promise]).then(function () {
            if (!vm.contract.buyer || !vm.contract.buyer.id) {
                return $q.reject();
            }
            return Company.get({id: vm.contract.buyer.id}).$promise;
        }).then(function (buyer) {
            vm.buyers.push(buyer);
        });
        vm.buyercontacts = Contact.query({filter: 'contract-is-null'});
        $q.all([vm.contract.$promise, vm.buyercontacts.$promise]).then(function () {
            if (!vm.contract.buyerContact || !vm.contract.buyerContact.id) {
                return $q.reject();
            }
            return Contact.get({id: vm.contract.buyerContact.id}).$promise;
        }).then(function (buyerContact) {
            vm.buyercontacts.push(buyerContact);
        });
        vm.thirdparties = Company.query({filter: 'contract-is-null'});
        $q.all([vm.contract.$promise, vm.thirdparties.$promise]).then(function () {
            if (!vm.contract.thirdParty || !vm.contract.thirdParty.id) {
                return $q.reject();
            }
            return Company.get({id: vm.contract.thirdParty.id}).$promise;
        }).then(function (thirdParty) {
            vm.thirdparties.push(thirdParty);
        });
        vm.thirdpartylocations = Location.query({filter: 'contract-is-null'});
        $q.all([vm.contract.$promise, vm.thirdpartylocations.$promise]).then(function () {
            if (!vm.contract.thirdPartyLocation || !vm.contract.thirdPartyLocation.id) {
                return $q.reject();
            }
            return Location.get({id: vm.contract.thirdPartyLocation.id}).$promise;
        }).then(function (thirdPartyLocation) {
            vm.thirdpartylocations.push(thirdPartyLocation);
        });
        vm.thirdpartycontacts = Contact.query({filter: 'contract-is-null'});
        $q.all([vm.contract.$promise, vm.thirdpartycontacts.$promise]).then(function () {
            if (!vm.contract.thirdPartyContact || !vm.contract.thirdPartyContact.id) {
                return $q.reject();
            }
            return Contact.get({id: vm.contract.thirdPartyContact.id}).$promise;
        }).then(function (thirdPartyContact) {
            vm.thirdpartycontacts.push(thirdPartyContact);
        });
        vm.loadingports = Port.query({filter: 'contract-is-null'});
        $q.all([vm.contract.$promise, vm.loadingports.$promise]).then(function () {
            if (!vm.contract.loadingPort || !vm.contract.loadingPort.id) {
                return $q.reject();
            }
            return Port.get({id: vm.contract.loadingPort.id}).$promise;
        }).then(function (loadingPort) {
            vm.loadingports.push(loadingPort);
        });
        vm.destinationports = Port.query({filter: 'contract-is-null'});
        $q.all([vm.contract.$promise, vm.destinationports.$promise]).then(function () {
            if (!vm.contract.destinationPort || !vm.contract.destinationPort.id) {
                return $q.reject();
            }
            return Port.get({id: vm.contract.destinationPort.id}).$promise;
        }).then(function (destinationPort) {
            vm.destinationports.push(destinationPort);
        });

        //Buyers
        vm.buyers = [];
        CompanyCustomService.returnCompaniesByType("BUYER").then(function (data) {
            vm.buyers = data.data;
        }, function (error) {
            console.log(error.status, error.statusText);
        });
        //Sellers

        //Should probably be commented out as long as we're in a "SALE-dialog.controller"
        vm.sellers = [];
        CompanyCustomService.returnCompaniesByType("SELLER").then(function (data) {
            vm.sellers = data.data;
        }, function (error) {
            console.log(error.status, error.statusText);
        });
        //Agents
        vm.agents = [];
        CompanyCustomService.returnCompaniesByType("AGENT").then(function (data) {
            vm.agents = data.data;
        }, function (error) {
            console.log(error.status, error.statusText);
        });
        //Locations & Contacts
        vm.buyerContacts = [];
        vm.sellerContacts = [];
        vm.agentContacts = [];

        function resolveShipments() {
            if (vm.contract.id) {
                // ShipmentCustomService.returnShipmentsByContract(vm.contract.id).then(function (data) {
                ShipmentCustomService.returnMinifiedShipmentsByContract(vm.contract.id).then(function (data) {
                    // ToastrService.success("Grabbed Existing Shipments", "Success!");
                    vm.contract.shipments = data.data;
                }, function (error) {
                    if (error.status !== "404") {
                        ToastrService.error("Failed to fetch existing shipments", "Error: " + error.message);
                    }
                });
            }
        }
        //fetch contact
        $scope.fetchContact = function (type) {
            switch (type) {
                case 'buyer':
                    if (vm.buyerContact !== null && vm.buyerContact !== "" && vm.buyerContact !== undefined) {
                        ContactCustomService.returnContact(vm.contract.buyer.id, vm.buyerContact).then(function (data) {
                            vm.contract.buyerContact = data.data;
                        }, function (error) {
                            console.log(error.status, error.statusText);
                        });
                    }
                    break;
                case 'seller':
                    if (vm.sellerContact !== null && vm.sellerContact !== "" && vm.sellerContact !== undefined) {
                        ContactCustomService.returnContact(vm.contract.seller.id, vm.sellerContact).then(function (data) {
                            vm.contract.sellerContact = data.data;
                        }, function (error) {
                            console.log(error.status, error.statusText);
                        });
                    }
                    break;
                case 'thirdParty':
                    if (vm.thirdPartyContact !== null && vm.thirdPartyContact !== "" && vm.thirdPartyContact !== undefined) {
                        ContactCustomService.returnContact(vm.contract.thirdParty.id, vm.thirdPartyContact).then(function (data) {
                            vm.contract.thirdPartyContact = data.data;
                        }, function (error) {
                            console.log(error.status, error.statusText);
                        });
                    }
                    break;
            }
        };
        //commodities
        vm.commodities = [
            {label: 'Cotton', value: 'COTTON'},
            {label: 'Yarn', value: 'YARN'},
            {label: 'Other', value: 'OTHER'}
        ];
        //growths
        vm.growths = [];
        Growth.query({size: 9000}, function (data) {
            vm.growths = data;
        }, function (error) {
            console.log(error.status, error.statusText);
        });
        //Wt Basis
        vm.wtBasises = [];
        KeywordCustomService.returnKeywordsByType("WtBasis").then(function (data) {
            vm.wtBasises = data.data;
        }, function (error) {
            console.log(error.status, error.statusText);
        });

        vm.rules = [];
        KeywordCustomService.returnKeywordsByType("Rules").then(function (data) {
            vm.rules = data.data;
        }, function (error) {
            console.log(error.status, error.statusText);
        });

        vm.shipmentMonths = MiscService.buildShipmentMonths();
        //Crop Year
        vm.cropYears = MiscService.returnCropYears();
        vm.resolveCropYear(vm.contract.cropYear);

        vm.listToKeywords = function(list) {
            var keywordsList = [];
            if (list) {
                for (var i = 0; i < list.length; i++) {
                    keywordsList.push({id: 'id_' + list[i], keyword: list[i]});
                }
            }
            return keywordsList;
        };

        vm.qualityDescriptionGrades = vm.listToKeywords(vm.qualityDescriptionGrade);
        KeywordCustomService.returnKeywordsByType("DescriptionGrade").then(function (data) {
            for (var i = 0; i < data.data.length; i++) {
                vm.qualityDescriptionGrades.push(data.data[i]);
            }
            for (var j = 0; j < vm.qualityDescriptionGrades.length; j++) {
                if (vm.qualityDescriptionGrades[j].keyword === vm.contract.gradeDescription) {
                    vm.contract.gradeDescription = vm.qualityDescriptionGrades[j];
                }
            }
        }, function (error) {
            console.log(error.status, error.statusText);
        });

        vm.qualityGreenCardGrades = vm.listToKeywords(vm.qualityGreenCardGrade);
        KeywordCustomService.returnKeywordsByType("GreenCardGrade").then(function (data) {
            for (var i = 0; i < data.data.length; i++) {
                vm.qualityGreenCardGrades.push(data.data[i]);
            }
            for (var j = 0; j < vm.qualityGreenCardGrades.length; j++) {
                if (vm.qualityGreenCardGrades[j].keyword === vm.contract.gradeGreenCard) {
                    vm.contract.gradeGreenCard = vm.qualityGreenCardGrades[j];
                }
            }
        }, function (error) {
            console.log(error.status, error.statusText);
        });

        vm.qualityGreenCardLeafs = vm.listToKeywords(vm.qualityGreenCardLeaf);
        KeywordCustomService.returnKeywordsByType("GreenCardLeaf").then(function (data) {
            for (var i = 0; i < data.data.length; i++) {
                vm.qualityGreenCardLeafs.push(data.data[i]);
            }
            for (var j = 0; j < vm.qualityGreenCardLeafs.length; j++) {
                if (vm.qualityGreenCardLeafs[j].keyword === vm.contract.leafGreenCard) {
                    vm.contract.leafGreenCard = vm.qualityGreenCardLeafs[j];
                }
            }
        }, function (error) {
            console.log(error.status, error.statusText);
        });

        vm.qualityDescriptionStaples = vm.listToKeywords(vm.qualityDescriptionStaple);
        KeywordCustomService.returnKeywordsByType("DescriptionStaple").then(function (data) {
            for (var i = 0; i < data.data.length; i++) {
                vm.qualityDescriptionStaples.push(data.data[i]);
            }
            for (var j = 0; j < vm.qualityDescriptionStaples.length; j++) {
                if (vm.qualityDescriptionStaples[j].keyword === vm.contract.stapleDescription) {
                    vm.contract.stapleDescription = vm.qualityDescriptionStaples[j];
                }
            }
        }, function (error) {
            console.log(error.status, error.statusText);
        });

        vm.qualityGreenCardStaples = vm.listToKeywords(vm.qualityGreenCardStaple);
        KeywordCustomService.returnKeywordsByType("GreenCardStaple").then(function (data) {
            for (var i = 0; i < data.data.length; i++) {
                vm.qualityGreenCardStaples.push(data.data[i]);
            }
            for (var j = 0; j < vm.qualityGreenCardStaples.length; j++) {
                if (vm.qualityGreenCardStaples[j].keyword === vm.contract.stapleGreenCard) {
                    vm.contract.stapleGreenCard = vm.qualityGreenCardStaples[j];
                }
            }
        }, function (error) {
            console.log(error.status, error.statusText);
        });

        vm.qualityDescriptionGreenCardMics = vm.listToKeywords(vm.qualityDescriptionGreenCardMic);
        KeywordCustomService.returnKeywordsByType("Mic").then(function (data) {
            for (var i = 0; i < data.data.length; i++) {
                vm.qualityDescriptionGreenCardMics.push(data.data[i]);
            }
            for (var j = 0; j < vm.qualityDescriptionGreenCardMics.length; j++) {
                if (vm.qualityDescriptionGreenCardMics[j].keyword === vm.contract.mic) {
                    vm.contract.mic = vm.qualityDescriptionGreenCardMics[j];
                }
            }
        }, function (error) {
            console.log(error.status, error.statusText);
        });

        vm.qualityDescriptionGreenCardStrengths = vm.listToKeywords(vm.qualityDescriptionGreenCardStrength);
        KeywordCustomService.returnKeywordsByType("Strength").then(function (data) {
            for (var i = 0; i < data.data.length; i++) {
                vm.qualityDescriptionGreenCardStrengths.push(data.data[i]);
            }
            for (var j = 0; j < vm.qualityDescriptionGreenCardStrengths.length; j++) {
                if (vm.qualityDescriptionGreenCardStrengths[j].keyword === vm.contract.strength) {
                    vm.contract.strength = vm.qualityDescriptionGreenCardStrengths[j];
                }
            }
        }, function (error) {
            console.log(error.status, error.statusText);
        });

        vm.qualityDescriptionGreenCardStrengthRanges = vm.listToKeywords(vm.qualityDescriptionGreenCardStrengthRange);
        KeywordCustomService.returnKeywordsByType("StrengthRange").then(function (data) {
            for (var i = 0; i < data.data.length; i++) {
                vm.qualityDescriptionGreenCardStrengthRanges.push(data.data[i]);
            }
            for (var j = 0; j < vm.qualityDescriptionGreenCardStrengthRanges.length; j++) {
                if (vm.qualityDescriptionGreenCardStrengthRanges[j].keyword === vm.contract.strengthRange) {
                    vm.contract.strengthRange = vm.qualityDescriptionGreenCardStrengthRanges[j];
                }
            }
        }, function (error) {
            console.log(error.status, error.statusText);
        });

        vm.qualityDescriptionGreenCardUniformitys = vm.listToKeywords(vm.qualityDescriptionGreenCardUniformity);
        KeywordCustomService.returnKeywordsByType("Unf").then(function (data) {
            for (var i = 0; i < data.data.length; i++) {
                vm.qualityDescriptionGreenCardUniformitys.push(data.data[i]);
            }
            for (var j = 0; j < vm.qualityDescriptionGreenCardUniformitys.length; j++) {
                if (vm.qualityDescriptionGreenCardUniformitys[j].keyword === vm.contract.unf) {
                    vm.contract.unf = vm.qualityDescriptionGreenCardUniformitys[j];
                }
            }
        }, function (error) {
            console.log(error.status, error.statusText);
        });

        vm.qualityDescriptionGreenCardRanges = vm.listToKeywords(vm.qualityDescriptionGreenCardRange);
        KeywordCustomService.returnKeywordsByType("Range").then(function (data) {
            for (var i = 0; i < data.data.length; i++) {
                vm.qualityDescriptionGreenCardRanges.push(data.data[i]);
            }
            for (var j = 0; j < vm.qualityDescriptionGreenCardRanges.length; j++) {
                if (vm.qualityDescriptionGreenCardRanges[j].keyword === vm.contract.range) {
                    vm.contract.range = vm.qualityDescriptionGreenCardRanges[j];
                }
            }
        }, function (error) {
            console.log(error.status, error.statusText);
        });

        vm.paymentTerms = [];
        KeywordCustomService.returnKeywordsByType("PaymentTerms").then(function (data) {
            vm.paymentTerms = data.data;
        }, function (error) {
            console.log(error.status, error.statusText);
        });

        //pricing years
        vm.pricingYears = MiscService.returnPricingYears();
        vm.shipmentPeriods = MiscService.returnShipmentPeriods();

        //countries
        CountryCustomService.returnAllCountries().then(function (data) {
            vm.countries = data.data;
        }, function (error) {
            console.log(error.status, error.statusText);
        });

        //Audits
        if (vm.contract.id) {
            ContractCustomService.returnContractAuditById(vm.contract.id).then(function (data) {
                vm.audits = data.data;
            }, function (error) {
                console.log(error.status, error.statusText);
            });
            vm.loadContractPricing();
            vm.hideFixations();
        }

        function refreshPricing(showFixations, pricing) {
            if (vm.contract.id) {
                Contract.get({id: vm.contract.id}, function (data) {
                    vm.contract.priceModel = data.priceModel;
                    vm.contract.fixedPrice = data.fixedPrice;
                    vm.contract.fixedPriceIc = data.fixedPriceIc;
                    vm.contract.priceType = data.priceType;
                    vm.contract.unitType = data.unitType;
                    vm.contract.priceValue = data.priceValue;
                    vm.contract.aggregatedUnfixedQty = data.aggregatedUnfixedQty;

                    vm.activatePriceModel(vm.contract.priceModel);
                    vm.activateUnitType(vm.contract.unitType);
                    if (vm.contract.priceModel === 'FIXED') {
                        vm.activatePriceType(vm.contract.priceType);
                        $scope.resolveDisplays('price');
                        vm.autoValueDisplay();
                        vm.autoPriceDisplay();
                    } else {
                        vm.hideFixations();
                        vm.loadContractPricing(showFixations, pricing);
                    }
                });
            }
        }

        vm.acCountryOptions = {
            dataTextField: "name",
            placeholder: "Select country..."
        };

        // pricing
        vm.predicate = 'id';
        vm.reverse = true;
        vm.predicateF = 'id';
        vm.reverseF = true;
        vm.loadingPricing = false;

        vm.openNewPricingDialogOnCreate = function () {
            $uibModal.open({
                templateUrl: 'app/entities/pricing/pricing-contract-dialog.html',
                controller: 'PricingDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            quantity: 0,
                            price: 0,
                            icPrice: 0,
                            onOff: 'ON',
                            month: null,
                            year: null,
                            priceType: 'CTS',
                            fixed: null,
                            unfixed: null,
                            id: null
                        };
                    },
                    contractPage: function () {
                        return true;
                    },
                    contractEntity: function () {
                        return {
                            id: null,
                            contractType: vm.contract.contractType,
                            category: vm.contract.category,
                            subCategory: vm.contract.subCategory
                        };
                    }
                }
            }).result.then(function (val) {
                var maxIndex = 1;
                for (var i = 0; i < vm.contractPricing.length; i++) {
                    if (vm.contractPricing[i].index > maxIndex) {
                        maxIndex = vm.contractPricing[i].index;
                    }
                }
                val.index = maxIndex + 1;
                val.fixed = 0;
                vm.contractPricing.push(val);
            }, function () {

            });
        };

        vm.openNewPricingDialog = function () {
            $uibModal.open({
                templateUrl: 'app/entities/pricing/pricing-contract-dialog.html',
                controller: 'PricingDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            quantity: 0,
                            price: 0,
                            icPrice: 0,
                            onOff: 'ON',
                            month: null,
                            year: null,
                            priceType: 'CTS',
                            fixed: null,
                            unfixed: null,
                            id: null
                        };
                    },
                    contractPage: function () {
                        return true;
                    },
                    contractEntity: function () {
                        return vm.contract;
                    }
                }
            }).result.then(function () {
                vm.refreshPricing();
            }, function () {
                vm.refreshPricing();
            });
        };

        vm.openEditPricing = function (pricing) {
            $uibModal.open({
                templateUrl: 'app/entities/pricing/pricing-contract-dialog.html',
                controller: 'PricingDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return pricing;
                    },
                    contractPage: function () {
                        return true;
                    },
                    contractEntity: function () {
                        return vm.contract;
                    }
                }
            }).result.then(function () {
                vm.refreshPricing();
            }, function () {
                vm.refreshPricing();
            });
        };

        vm.openFixationDialogForPricing = function (pricing) {
            $uibModal.open({
                templateUrl: 'app/entities/contract/fixation/fixation-pricing-dialog.html',
                controller: 'FixationPricingDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            createdOn: new Date(),
                            createdBy: vm.account.login,
                            modifiedOn: new Date(),
                            modifiedBy: vm.account.login,
                            quantity: 0,
                            futurePrice: 0,
                            finalPriceFixationAmount: 0,
                            interCompAmount: 0,
                            unitType: vm.contract.qtyUnitType,
                            pricing: pricing,
                            contract: vm.contract
                        };
                    }
                }
            }).result.then(function () {
                vm.refreshPricing(true, pricing);
            }, function () {
                vm.refreshPricing();
            });
        };

        vm.openEditFixation = function (fixation) {
            $uibModal.open({
                templateUrl: 'app/entities/contract/fixation/fixation-pricing-dialog.html',
                controller: 'FixationPricingDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return fixation;
                    }
                }
            }).result.then(function () {
                vm.refreshPricing(true, fixation.pricing);
            }, function () {
                vm.refreshPricing();
            });
        };

        vm.deleteFixation = function( fixation ) {
            $uibModal.open({
                templateUrl: 'app/entities/contract/fixation/fixation-delete-dialog.html',
                controller: 'FixationPricingDeleteDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: function() {
                        return fixation;
                    }
                }
            }).result.then( function() {
                vm.refreshPricing();
            }, function() {
                vm.refreshPricing();
            });
        }

        vm.showFixationsForPricing = function (pricing) {
            vm.fixationsHeader = "Fixation(s) for Pricing " + pricing.label + ": " + pricing.month + ", " + pricing.year + ", " + pricing.priceType;
            // vm.loadContractFixations(pricing.id);
            vm.loadContractFixations(pricing);
        };

        vm.fixationsHeader = "Fixations";
        vm.updateFixationsVisibility = function (pricing) {
            pricing.showFixations = !pricing.showFixations;
            if (pricing.showFixations) {
                vm.fixationsHeader = "Fixation(s) for Pricing " + pricing.label + ": " + pricing.month + ", " + pricing.year + ", " + pricing.priceType;
                vm.hideFixations();
                pricing.showFixations = true;
                vm.showFixations = true;
                // vm.loadContractFixations(pricing.id);
                vm.loadContractFixations(pricing);
            } else {
                vm.hideFixations();
            }
        };

        function loadContractPricing(showFixations, pricing) {
            vm.predicate = 'id';
            vm.reverse = true;
            vm.contractPricing = [];
            vm.loadingPricing = true;
            vm.contractPricingQtyTotal = 0;
            vm.contractPricingFixedTotal = 0;
            vm.contractPricingUnfixedTotal = 0;
            ContractCustomService.returnContractPricing(vm.contract.id).then(function (data) {
                vm.loadingPricing = false;
                vm.contractPricing = data.data;
                for (var i = 0; i < vm.contractPricing.length; i++) {
                    vm.contractPricing[i].index = i + 1;
                    vm.contractPricing[i].showFixations = false;
                    vm.contractPricingQtyTotal += vm.contractPricing[i].quantity;
                    vm.contractPricingFixedTotal += vm.contractPricing[i].fixed === null ? 0 : vm.contractPricing[i].fixed;
                }
                vm.contractPricingUnfixedTotal = vm.contractPricingQtyTotal - vm.contractPricingFixedTotal;
                if (showFixations !== undefined && showFixations === true) {
                    vm.showFixations = true;
                    for (i = 0; i < vm.contractPricing.length; i++) {
                        if (vm.contractPricing[i].id === pricing.id) {
                            vm.contractPricing[i].showFixations = true;
                            vm.showFixationsForPricing(pricing);
                        }
                    }
                }
                vm.autoPriceDisplay();
            }, function () {
                vm.loadingPricing = false;
                vm.contractPricing = [];
            })
        }

        // function loadContractFixations(id) {
        function loadContractFixations(pricing) {
            if (pricing && pricing.id > 0) {
                vm.predicateF = 'id';
                vm.reverseF = true;
                vm.contractFixations = [];
                PricingCustomService.getFixationsByPricing(pricing.id).then(function (data) {
                    vm.contractFixations = data.data;
                    vm.contractFixationsAvg = 0;
                    vm.contractFinalFixationsAvg = 0;
                    vm.contractFixationsQtyTotal = 0;
                    for (var i = 0; i < vm.contractFixations.length; i++) {
                        vm.contractFixations[i].index = i + 1;
                        vm.contractFixations[i].pricing = pricing;
                        vm.contractFixations[i].contract = vm.contract;
                        vm.contractFixationsAvg += vm.contractFixations[i].finalPriceFixationAmount * vm.contractFixations[i].quantity;
                        vm.contractFinalFixationsAvg += vm.contractFixations[i].interCompPrice * vm.contractFixations[i].quantity;
                        vm.contractFixationsQtyTotal += vm.contractFixations[i].quantity;
                    }
                    if (vm.contractFixations.length !== 0) {
                        vm.contractFixationsAvg = Math.round((vm.contractFixationsAvg / vm.contractFixationsQtyTotal) * 100) / 100;
                        vm.contractFinalFixationsAvg = Math.round((vm.contractFinalFixationsAvg / vm.contractFixationsQtyTotal) * 100 ) / 100;
                    }
                }, function () {
                    vm.contractFixations = [];
                })
            } else {
                vm.hideFixations();
            }
        }

        function hideFixations() {
            for (var i = 0; i < vm.contractPricing.length; i++) {
                vm.contractPricing[i].index = i + 1;
                vm.contractPricing[i].showFixations = false;
            }
            vm.showFixations = false;
        }

        vm.loadingPorts = [];
        vm.destinationPorts = [];
        // -->
        $scope.fetchPorts = function (type) {
            switch (type) {
                case 'origin':
                    if (vm.contract.loadingCountry !== null && vm.contract.loadingCountry !== "" && vm.contract.loadingCountry !== undefined) {
                        PortCustomService.getPortsByCountry(vm.contract.loadingCountry.id).then(function (data) {
                            vm.loadingPorts = data.data;
                        }, function (error) {
                            console.log(error.status, error.statusText);
                        });
                    }
                    break;
                case 'destination':
                    if (vm.contract.destinationCountry !== null && vm.contract.destinationCountry !== "" && vm.contract.destinationCountry !== undefined) {
                        PortCustomService.getPortsByCountry(vm.contract.destinationCountry.id).then(function (data) {
                            vm.destinationPorts = data.data;
                        }, function (error) {
                            console.log(error.status, error.statusText);
                        });
                    }
                    break;
            }
        };
        //resolve port display
        $scope.resolvePortDisplays = function (type) {
            switch (type) {
                case 'origin':
                    vm.contract.loadingPortDisplay = ((vm.contract.loadingCountry && vm.contract.loadingCountry !== null) ? vm.contract.loadingCountry.name : '')
                        + ((vm.contract.loadingCountry && vm.contract.loadingCountry !== null && vm.contract.loadingPort && vm.contract.loadingPort !== null) ? ' - ' : '')
                        + ((vm.contract.loadingPort && vm.contract.loadingPort !== null) ? vm.contract.loadingPort.name : '');
                    break;
                case 'destination':
                    vm.contract.destinationPortDisplay = ((vm.contract.destinationCountry && vm.contract.destinationCountry !== null) ? vm.contract.destinationCountry.name : '')
                        + ((vm.contract.destinationCountry && vm.contract.destinationCountry !== null && vm.contract.destinationPort && vm.contract.destinationPort !== null) ? ' - ' : '')
                        + ((vm.contract.destinationPort && vm.contract.destinationPort !== null) ? vm.contract.destinationPort.name : '');
                    break;
            }
        };

        $scope.resolveGrowthDisplay = function () {
            if (vm.contract.growth && vm.contract.growth !== null) {
                if (vm.contract.growth.parent && vm.contract.growth.parent !== null) {
                    vm.contract.growthDisplay = vm.contract.growth.parent.location + ' - ' + vm.contract.growth.location;
                } else {
                    vm.contract.growthDisplay = vm.contract.growth.location;
                }
            } else {
                vm.contract.growthDisplay = '';
            }
        };

        $scope.resolveIncoTermsDisplay = function() {
            if( vm.contract.incoTerms && vm.contract.incoTerms !== null ) {
                vm.contract.incoTermsDisplay = vm.contract.incoTerms;
            }
        }

        //resolve displays
        $scope.resolveDisplays = function (type) {
            switch (type) {
                case 'price':
                    vm.autoPriceDisplay();
                    break;
                case 'Grade':
                    if (vm.contract.grade === '--new--') {
                        vm.contract.grade = '';
                        $scope.enterNewKeyword(type);
                    } else {
                        vm.contract.gradeDisplay = vm.contract.grade;
                    }
                    $timeout(function () {
                        angular.element(document.querySelector('#inpt-mic')).focus();
                    });
                    break;
                case 'Mic':
                    if (vm.contract.mic === '--new--') {
                        vm.contract.mic = '';
                        $scope.enterNewKeyword(type);
                    } else {
                        vm.contract.micDisplay = vm.contract.mic;
                    }
                    $timeout(function () {
                        angular.element(document.querySelector('#inpt-stple')).focus();
                    });
                    break;
                case 'Staple':
                    if (vm.contract.staple === '--new--') {
                        vm.contract.staple = '';
                        $scope.enterNewKeyword(type);
                    } else {
                        vm.contract.stapleDisplay = vm.contract.staple;
                    }
                    $timeout(function () {
                        angular.element(document.querySelector('#inpt-strength')).focus();
                    });
                    break;
                case 'Strength':
                    if (vm.contract.strength === '--new--') {
                        vm.contract.strength = '';
                        $scope.enterNewKeyword(type);
                    } else {
                        vm.contract.strengthDisplay = vm.contract.strength;
                    }
                    $timeout(function () {
                        angular.element(document.querySelector('#inpt-strength')).focus();
                    });
                    break;
                case 'Unf':
                    if (vm.contract.unf === '--new--') {
                        vm.contract.unf = '';
                        $scope.enterNewKeyword(type);
                    } else {
                        vm.contract.unfDisplay = vm.contract.unf;
                    }
                    $timeout(function () {
                        angular.element(document.querySelector('#inpt-unf')).focus();
                    });
                    break;
                case 'WtBasis':
                    vm.contract.wtBasis = '';
                    $scope.enterNewKeyword(type);
                    break;
                case 'IncoTerms':
                    $scope.enterNewKeyword(type);
                    break;
                case 'Growth':
                    $scope.enterNewGrowth();
                    break;
                case 'LoadPort':
                    $scope.enterNewKeyword(type);
                    break;
            }
        };

        vm.activityhistories = vm.contract.id === null ? [] : ActivityHistory.query({'contractId': vm.contract.id});

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function autoQualityDisplay( auto ) {
            if( ( vm.contract.id === null && !vm.isSaving ) || auto ) {
                vm.contract.qualityDescriptionDisplay =
                    MiscService.buildQualityDisplay(vm.contract.gradeDescriptionDisplay, null, vm.contract.stapleDescriptionDisplay, vm.contract.micDisplay,
                        vm.contract.strengthDisplay, vm.contract.strengthRangeDisplay, vm.contract.unfDisplay, vm.contract.rangeDisplay);
                vm.contract.qualityGreenCardDisplay =
                    MiscService.buildQualityDisplay(vm.contract.gradeGreenCardDisplay, vm.contract.leafGreenCardDisplay, vm.contract.stapleGreenCardDisplay, vm.contract.micDisplay,
                        vm.contract.strengthDisplay, vm.contract.strengthRangeDisplay, vm.contract.unfDisplay, vm.contract.rangeDisplay);
            }
        }

        function autoQtyDisplay() {
            vm.contract.qtyDisplay = MiscService.buildQtyDisplay(vm.contract.quantity, vm.contract.qtyUnitType, ' (' + vm.altQty + ') ', vm.contract.tolType, vm.contract.tolerance);
        }
        function autoShipPerDisplay() {
            ToastrService.success("Not implemented.  Please enter manually");
            angular.element('shipPerDispInput').focus();
        }

        function clear() {
            // FIXME not used. remove invocation to me
        }

        function resolveQualities() {
            if (vm.contract.gradeDescription && vm.contract.gradeDescription.keyword) {
                vm.contract.gradeDescription = vm.contract.gradeDescription.keyword;
            }
            if (vm.contract.stapleDescription && vm.contract.stapleDescription.keyword) {
                vm.contract.stapleDescription = vm.contract.stapleDescription.keyword;
            }
            if (vm.contract.mic && vm.contract.mic.keyword) {
                vm.contract.mic = vm.contract.mic.keyword;
            }
            if (vm.contract.strength && vm.contract.strength.keyword) {
                vm.contract.strength = vm.contract.strength.keyword;
            }
            if (vm.contract.strengthRange && vm.contract.strengthRange.keyword) {
                vm.contract.strengthRange = vm.contract.strengthRange.keyword;
            }
            if (vm.contract.unf && vm.contract.unf.keyword) {
                vm.contract.unf = vm.contract.unf.keyword;
            }
            if (vm.contract.range && vm.contract.range.keyword) {
                vm.contract.range = vm.contract.range.keyword;
            }
            if (vm.contract.gradeGreenCard && vm.contract.gradeGreenCard.keyword) {
                vm.contract.gradeGreenCard = vm.contract.gradeGreenCard.keyword;
            }
            if (vm.contract.leafGreenCard && vm.contract.leafGreenCard.keyword) {
                vm.contract.leafGreenCard = vm.contract.leafGreenCard.keyword;
            }
            if (vm.contract.stapleGreenCard && vm.contract.stapleGreenCard.keyword) {
                vm.contract.stapleGreenCard = vm.contract.stapleGreenCard.keyword;
            }

        }

        function save() {
            vm.isSaving = true;
            if (vm.contract.priceModel === 'ONCALL') {
                vm.contract.fixedPriceValue = 0;
            }
            vm.autoPriceDisplay();
            vm.resolveQualities();
            vm.contract.plannedShipments = vm.plannedShipmentsNew;
            if (vm.contract.id !== null) {
                if (vm.contract.priceModel === 'ONCALL'
                    || (vm.contractFixations.length === 0 && vm.contractPricing.length === 0)
                    || confirm("Note, all current pricing and fixation data will be destroyed.") === true) {
                    Contract.update(vm.contract, onSaveSuccess, onSaveError);
                }
            } else {
                Contract.save(vm.contract, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            var newContract = vm.contract.id === null;
            vm.contract.id = result.id;
            if (newContract) {
                var promlist = [];
                resolveDates();
                if (vm.comments.length > 0) {
                    var comments = [];
                    for (var x = 0; x < vm.comments.length; x++) {
                        if (vm.comments[x].id === null) {
                            comments.push(vm.comments[x]);
                        }
                    }
                    if (comments.length > 0) {
                        promlist.push(CommentCustomService.assignParentToComment(vm.comments, vm.contract.id, "contract"));
                    }
                }
                if ($scope.files && $scope.files.length > 0) {
                    angular.forEach($scope.files, function (file) {
                        promlist.push(AttachmentCustomService.uploadAttachment(file, "contract", vm.contract.id, file.name));
                    });
                }
                for (var i = 0; i < vm.contractPricing.length; i++) {
                    vm.contractPricing[i].contract = vm.contract;
                    promlist.push(Pricing.save(vm.contractPricing[i]).$promise);
                }
                if (vm.comments.length > 0) {
                    var comments = [];
                    for (var x = 0; x < vm.comments.length; x++) {
                        if (vm.comments[x].id === null) {
                            comments.push(vm.comments[x]);
                        }
                    }
                    if (comments.length > 0) {
                        promlist.push(CommentCustomService.assignParentToComment(vm.comments, vm.contract.id, "contract"));
                    }
                }
                if (promlist.length > 0) {
                    $q.all(promlist).then(function () {
                        finalizeSave();
                    }).then(function () {
                        finalizeSave();
                    });
                } else {
                    finalizeSave();
                }
            } else {
                finalizeSave();
            }
        }

        function finalizeSave() {
            vm.isSaving = false;
            ToastrService.success("Successfully saved Contract", "Success!");
            if (vm.category.type === 'SALE') {
                var data = {
                    heading: 'Detail ' + vm.contract.contractNum,
                    route: 'sale.sale-detail',
                    id: vm.contract.id,
                    param: {id: ''}
                };
            } else {
                data = {
                    heading: 'Detail ' + vm.contract.contractNum,
                    route: 'purchase.purchase-detail',
                    id: vm.contract.id,
                    param: {id: ''}
                };
            }
            $rootScope.$emit('handleEmit', data);
        }

        function onSaveError() {
            ToastrService.error("Something went wrong", "Error!");
            resolveDates();
            vm.isSaving = false;
            $scope.activeTab = vm.getActiveTab();
        }

        function getActiveTab() {
            if (vm.contract.category === undefined || vm.contract.category === null
                || vm.contract.subCategory === undefined || vm.contract.subCategory === null
                || vm.contract.status === undefined || vm.contract.status === null
                || vm.contract.contractNum === undefined || vm.contract.contractNum === null
                || vm.contract.contractDate === undefined || vm.contract.contractDate === null) {
                return 0;
            }
            if (vm.contract.contractType === 'PURCHASE'
                && (vm.contract.seller === undefined || vm.contract.seller === null)) {
                return 0;
            }
            if (vm.contract.contractType === 'SALE'
                && (vm.contract.buyer === undefined || vm.contract.buyer === null)) {
                return 0;
            }
            if (vm.contract.growth === undefined || vm.contract.growth === null
                || vm.contract.cropYear === undefined || vm.contract.cropYear === null) {
                return 1;
            }
            if ((vm.contract.quantity === undefined || vm.contract.quantity === null)
                || (vm.contract.priceModel === 'FIXED'
                    && (vm.contract.priceValue === undefined || vm.contract.priceValue === null))) {
                return 2;
            }
        }

        vm.datePickerOpenStatus.createdOn = false;
        vm.datePickerOpenStatus.modifiedOn = false;
        vm.datePickerOpenStatus.contractDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
            vm.datePickerOpenStatus[date] = true;
        }

        function resolveDates() {
            if (vm.contract.contractDate !== null) {
                vm.contract.contractDate = MiscService.dateFix(vm.contract.contractDate);
            }
        }

        $scope.openContractDate = function () {
            $scope.contractDate.opened = true;
        };

        $scope.contractDate = {
            opened: false
        };

        $scope.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        $scope.$watchGroup(['vm.contract.mic', 'vm.contract.micDisplay',
                'vm.contract.staple', 'vm.contract.stapleDisplay', 'vm.contract.strength', 'vm.contract.strengthDisplay',
                'vm.contract.unf', 'vm.contract.unfDisplay', 'vm.contract.gradeDescription', 'vm.contract.gradeDescriptionDisplay',
                'vm.contract.stapleDescription', 'vm.contract.stapleDescriptionDisplay', 'vm.contract.gradeGreenCard', 'vm.contract.gradeGreenCardDisplay',
                'vm.contract.leafGreenCard', 'vm.contract.leafGreenCardDisplay', 'vm.contract.stapleGreenCard', 'vm.contract.stapleGreenCardDisplay',
                'vm.contract.strengthRange', 'vm.contract.strengthRangeDisplay', 'vm.contract.range', 'vm.contract.rangeDisplay'], function(newValue, oldValue) {
            vm.autoQualityDisplay( false );
        });

        $scope.enterNewKeyword = function(type) {
            $uibModal.open({
                templateUrl: 'app/entities/keyword/keyword-dialog.html',
                controller: 'KeywordDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function () {
                        return {
                            createdOn: new Date(),
                            createdBy: "user",
                            modifiedOn: new Date(),
                            modifiedBy: "user",
                            type: type,
                            value: null,
                            desc: null,
                            id: null
                        };
                    }
                }
            }).result.then(function (retVal) {
                switch (retVal.type) {
                    case 'DescriptionGrade' :
                        vm.qualityDescriptionGrades.push(retVal);
                        vm.contract.gradeDescription = retVal;
                        vm.contract.gradeDescriptionDisplay = vm.contract.gradeDescription.keyword;
                        break;
                    case 'GreenCardGrade' :
                        vm.qualityGreenCardGrades.push(retVal);
                        vm.contract.gradeGreenCard = retVal;
                        vm.contract.gradeGreenCardDisplay = vm.contract.gradeGreenCard.keyword;
                        break;
                    case 'GreenCardLeaf' :
                        vm.qualityGreenCardLeafs.push(retVal);
                        vm.contract.leafGreenCard = retVal;
                        vm.contract.leafGreenCardDisplay = vm.contract.leafGreenCard.keyword;
                        break;
                    case 'DescriptionStaple' :
                        vm.qualityDescriptionStaples.push(retVal);
                        vm.contract.stapleDescription = retVal;
                        vm.contract.stapleDescriptionDisplay = vm.contract.stapleDescription.keyword;
                        break;
                    case 'GreenCardStaple' :
                        vm.qualityGreenCardStaples.push(retVal);
                        vm.contract.stapleGreenCard = retVal;
                        vm.contract.stapleGreenCardDisplay = vm.contract.stapleGreenCard.keyword;
                        break;
                    case 'Mic' :
                        vm.qualityDescriptionGreenCardMics.push(retVal);
                        vm.contract.mic = retVal;
                        vm.contract.micDisplay = vm.contract.mic.keyword;
                        break;
                    case 'Strength' :
                        vm.qualityDescriptionGreenCardStrengths.push(retVal);
                        vm.contract.strength = retVal;
                        vm.contract.strengthDisplay = vm.contract.strength.keyword;
                        break;
                    case 'StrengthRange' :
                        vm.qualityDescriptionGreenCardStrengthRanges.push(retVal);
                        vm.contract.strengthRange = retVal;
                        vm.contract.strengthRangeDisplay = vm.contract.strengthRange.keyword;
                        break;
                    case 'Unf' :
                        vm.qualityDescriptionGreenCardUniformitys.push(retVal);
                        vm.contract.unf = retVal;
                        vm.contract.unfDisplay = vm.contract.unf.keyword;
                        break;
                    case 'Range' :
                        vm.qualityDescriptionGreenCardRanges.push(retVal);
                        vm.contract.range = retVal;
                        vm.contract.rangeDisplay = vm.contract.range.keyword;
                        break;

                    case 'WtBasis' :
                        vm.wtBasises.push(retVal);
                        vm.contract.wtBasis = retVal.keyword;
                        vm.contract.wtBasisDisplay = vm.contract.wtBasis;
                        break;
                    case 'IncoTerms' :
                        vm.incoTerms.push(retVal);
                        vm.contract.incoTerms = retVal.keyword;
                        vm.contract.incoTermsDisplay = vm.contract.incoTerms;
                        $timeout(function () {
                            angular.element(document.querySelector('#inpt-loadCntry')).focus();
                        });
                        break;
                    case 'PaymentTerms' :
                        vm.paymentTerms.push(retVal);
                        vm.contract.paymentTerms = retVal.keyword;
                        vm.contract.paymentTermsDisplay = vm.contract.paymentTerms;
                        $timeout(function () {
                            angular.element(document.querySelector('#inpt-loadCntry')).focus();
                        });
                        break;
                    case 'Growth' :
                        vm.growths.push(retVal);
                        vm.contract.growth = retVal;
                        vm.contract.growthDisplay = vm.contract.growth;
                        $timeout(function () {
                            angular.element(document.querySelector('#inpt-cropYear')).focus();
                        });
                        break;
                    case 'LoadPort' :
                        vm.loadingPorts.push(retVal);
                        vm.contract.loadingPort = retVal;
                        break;
                }
            }, function (error) {
                console.log(error.status, error.statusText)
            });
        };

        $scope.enterNewGrowth = function() {
            $uibModal.open({
                templateUrl: 'app/entities/growth/growth-dialog.html',
                controller: 'GrowthDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function () {
                        return {
                            createdOn: new Date(),
                            createdBy: "user",
                            modifiedOn: new Date(),
                            modifiedBy: "user",
                            location: null,
                            description: null,
                            parentId: null,
                            id: null
                        };
                    }
                }
            }).result.then(function (retVal) {
                vm.growths.push(retVal);
                vm.contract.growth = retVal;
                $timeout(function () {
                    if (retVal.parent && retVal.parent !== null) {
                        vm.contract.growthDisplay = retVal.parent.location + ' - ' + vm.contract.growth.location;
                    } else {
                        vm.contract.growthDisplay = vm.contract.growth.location;
                    }
                    angular.element(document.querySelector('#inpt-cropYear')).focus();
                });
            }, function (error) {
                console.log(error.status, error.statusText)
            });
        };

        $scope.$watch('vm.contract.growth', function () {
            $scope.resolveGrowthDisplay();
        });

        $scope.enterNewCompany = function (type) {
            $uibModal.open({
                templateUrl: 'app/entities/company/company-dialog.html',
                controller: 'CompanyDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: function () {
                        return {
                            createdOn: new Date(),
                            createdBy: "user",
                            modifiedOn: new Date(),
                            modifiedBy: "user",
                            type: type.toUpperCase(),
                            name: null,
                            accountNum: null,
                            locations: null
                        };
                    },
                    showTypes: function () {
                        return true;
                    }
                }
            }).result.then(function (retVal) {
                switch (retVal.type) {
                    case 'BUYER' :
                        vm.buyers.push(retVal);
                        vm.contract.buyer = retVal;
                        $timeout(function () {
                            angular.element(document.querySelector('#buyerLocation')).focus();
                        });
                        $scope.enterNewLocation(vm.contract.buyer);

                        break;
                    case 'SELLER' :
                        vm.sellers.push(retVal);
                        vm.contract.seller = retVal;
                        $timeout(function () {
                            angular.element(document.querySelector('#sellerLocation')).focus();
                        });
                        $scope.enterNewLocation(vm.contract.seller);
                        break;
                    case 'AGENT' :
                        vm.agents.push(retVal);
                        vm.contract.thirdParty = retVal;
                        $timeout(function () {
                            angular.element(document.querySelector('#thirdPartyLocation')).focus();
                        });
                        $scope.enterNewLocation(vm.contract.thirdParty);
                        break;

                }


            }, function (error) {
                console.log(error.status, error.statusText)
            });
        };

        function generateUUID() {
            var d = new Date().getTime();
            if (window.performance && typeof window.performance.now === "function") {
                d += performance.now(); //use high-precision timer if available
            }
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
        }

        /*
        Attachments Stuff
         */
        //attachment actions
        vm.deleteTempAttachment = deleteTempAttachment;
        vm.downloadAttachment = downloadAttachment;
        vm.deleteAttachment = deleteAttachment;

        $scope.files = [];
        $scope.uploadFile = function (file) {
            if( file && file.length ) {
                angular.forEach( file, function( file ) {
                    $scope.files.push( file );
                    if( vm.contract.id !== null ) {
                        AttachmentCustomService.uploadAttachment( file, "contract", vm.contract.id, file.name ).then( function( data ) {
                            vm.attachments.push( data.data );
                            ToastrService.success( "Successfully uploaded Attachment", "Success!");
                        }, function( error ) {
                            if( error.status !== 404 ) {
                                ToastrService.error( "Failed to Upload Attachment: " + error.statusText, "Error" );
                            }
                            console.log( error.statusText );
                        });
                        var index = $scope.files.indexOf( file );
                        $scope.files.splice( index, 1 );
                    }
                });
            }
        };

        function deleteTempAttachment( index ) {
            $uibModal.open({
                templateUrl: 'app/entities/attachment/modal/attachment-remove-modal.html',
                controller: 'AttachmentRemoveModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function () {
                        return $scope.files[index];
                    }
                }
            }).result.then(function (retVal) {
                if (retVal == true) {
                    $scope.files.splice( index, 1 );
                    ToastrService.success("Successfully removed Attachment", "Success!");
                } else {
                    ToastrService.error("Something went wrong", "Error!");
                }
            });
        }

        function downloadAttachment( attachment ) {
            AttachmentCustomService.downloadAttachment( attachment.id ).then( function( data, status, headers, config ) {
                var file = new Blob([data.data], {type: 'application/octet-stream'});
                saveAs(file, attachment.fileName );
            }, function( error ) {
                if( error.status !== 404 ) {
                    ToastrService.error( "Something went wrong: " + error.statusText, "Error");
                    console.log( error.statusText );
                }
            });
        }

        function deleteAttachment( index ) {
            $uibModal.open({
                templateUrl: 'app/entities/attachment/modal/attachment-delete-modal.html',
                controller: 'AttachmentDeleteModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: function () {
                        return vm.attachments[index];
                    }
                }
            }).result.then(function (retVal) {
                if (retVal == true) {
                    vm.attachments.splice( index, 1 );
                } else {
                    ToastrService.error("Something went wrong", "Error!");
                }
            });
        }

        function resolveAttachments() {
            AttachmentCustomService.returnAttachmentsByContract( vm.contract.id ).then( function( data ) {
                vm.attachments = data.data;
                // if( vm.attachments.length > 0 ) {
                //     ToastrService.success( "Fetched Attachments", "Success!");
                // }
            }, function( error ) {
                if( error.status !== 404 ) {
                    ToastrService.error( "Cannot fetch Attachments", "Error" );
                }
                console.log( error.statusText );
            });
        }

        /*
        ANYTHING THAT HAS SOMETHING TO DO WITH COMMENTS IS BELOW
         */
        vm.addComment = addComment;
        vm.editComment = editComment;
        vm.editUnsavedComment = editUnsavedComment;
        vm.showCommentAudit = showCommentAudit;
        vm.verifyCommentDelete = verifyCommentDelete;
        vm.verifyCommentUnsavedDelete = verifyCommentUnsavedDelete;

        //action behind the add comment button
        function addComment() {
            if( vm.comment.length > 0 ) { //if there is actual comment
                //create comment object then push to lot.comments
                if( vm.contract.id !== null ) { //save comment
                    var comment = [];
                    comment.push( createComment( vm.comment ) );
                    CommentCustomService.assignParentToComment( comment, vm.contract.id, "contract" ).then( function() {
                        resolveComments();
                        ToastrService.success( "Added Comment to Contract", "Success!" );
                    }, function( error ) {
                        ToastrService.error("Failed to save comment: " + error.statusText, "Error");
                        console.log( error.statusText );
                    });
                } else { //push to array to be saved along with the lot
                    vm.comments.push( createComment( vm.comment ) );
                    ToastrService.info( "Added Comment to Contract", "Info" );
                }
                //clear comment text area
                vm.comment = "";
            }
        }

        //create comment object
        function createComment( comment ) {
            var by = "user";
            if( vm.account.login !== undefined ) {
                by = vm.account.login;
            }
            var com = {
                "id": null,
                "createdOn": new Date(),
                "createdBy": by,
                "modifiedOn": new Date(),
                "modifiedBy": by,
                "comment": comment,
                "active": true
            };
            return com;
        }

        //edit existing comment
        function editComment( index ) {
            $uibModal.open({
                templateUrl: 'app/entities/comment/comment-dialog.html',
                controller: 'CommentDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: function() {
                        return vm.comments[ index ];
                    },
                    shipmentEntity: function() {
                        return null;
                    },
                    contractEntity: function() {
                        return Contract.get({id: vm.contract.id}).$promise;
                    },
                    lotEntity: function() {
                        return null;
                    },
                    invoiceEntity: function() {
                        return null;
                    },
                    requiredDocumentEntity: function() {
                        return null;
                    },
                    controllerEntity: function() {
                        return null;
                    },
                    controllerPaymentEntity: function() {
                        return null;
                    }
                }
            }).result.then( function( retVal ) {
                ToastrService.success( "Successfully Updated Comment", "Success!" );
                vm.comments[ index ] = retVal;
            });
        }

        //edit comment saved in memory
        function editUnsavedComment( index ) {
            $uibModal.open({
                templateUrl: 'app/entities/comment/comment-unsaved-dialog.html',
                controller: 'CommentUnsavedDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function() {
                        return vm.comments[index];
                    }
                }
            }).result.then( function( retVal ) {
                ToastrService.success( "Successfully Updated Comment", "Success!" );
                vm.comments[ index ] = retVal;
            });
        }

        //show comment audit trail
        function showCommentAudit( id ) {
            $uibModal.open({
                templateUrl: 'app/entities/comment/comment-audit-dialog.html',
                controller: 'CommentAuditDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function() {
                        return Comment.get({ id: id }).$promise;
                    }
                }
            }).result.then( function() {
                // resolveComments();
            });
        }

        //delete existing comment
        function verifyCommentDelete( index ) {
            $uibModal.open({
                templateUrl: 'app/entities/comment/comment-delete-dialog.html',
                controller: 'CommentDeleteController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function() {
                        return vm.comments[index];
                    },
                    shipmentEntity: function() {
                        return null;
                    },
                    contractEntity: function() {
                        return Contract.get({ id: vm.contract.id }).$promise;
                    },
                    lotEntity: function() {
                        return null;
                    },
                    invoiceEntity: function() {
                        return null;
                    },
                    requiredDocumentEntity: function() {
                        return null;
                    }
                }
            }).result.then( function( retVal ) {
                if( retVal == true ) {
                    ToastrService.success( "Successfully deleted Comment", "Success!" );
                    vm.comments.splice( index, 1 );
                } else {
                    ToastrService.error( "Something went wrong", "Error!" );
                }
            });
        }

        //delete comment saved in memory
        function verifyCommentUnsavedDelete( index ) {
            $uibModal.open({
                templateUrl: 'app/entities/comment/comment-unsaved-delete-dialog.html',
                controller: 'CommentUnsavedDeleteDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function() {
                        return vm.comments[ index ];
                    }
                }
            }).result.then( function( retVal ) {
                if( retVal === true ) {
                    ToastrService.success( "Successfully deleted Comment", "Success!" );
                    vm.comments.splice( index, 1 );
                } else {
                    ToastrService.error( "Something went wrong", "Error!" );
                }
            });
        }

        function resolveComments() {
            vm.comments.length = 0;
            CommentCustomService.returnCommentsByContract( vm.contract.id ).then( function( data ) {
                vm.comments = data.data;
                // if( vm.comments.length > 0 ) {
                //     ToastrService.success( "Fetched Comments", "Success!");
                // }
            }, function( error ) {
                if( error.status !== 404 ) {
                    ToastrService.error( "Cannot get Comments: " + error.statusText, "Error!" );
                }
                console.log( error.statusText );
            });
        }
    }
})();
